export const AUTOMATION_EFFECTIVE_STATUS = {
  ACTIVE: "active",
  WAITING_FOR_CONTENT: "waiting_for_content",
  NEEDS_ATTENTION: "needs_attention",
  PAUSED: "paused",
  OFF: "off",
  ENDED: "ended",
};

export const isAutomationSwitchOn = (status) =>
  status === AUTOMATION_EFFECTIVE_STATUS.ACTIVE ||
  status === AUTOMATION_EFFECTIVE_STATUS.WAITING_FOR_CONTENT ||
  status === AUTOMATION_EFFECTIVE_STATUS.NEEDS_ATTENTION ||
  status === AUTOMATION_EFFECTIVE_STATUS.ENDED;

export const canToggleAutomation = (status) =>
  status !== AUTOMATION_EFFECTIVE_STATUS.OFF;

export const isAutomationScheduling = ({
  effectiveStatus,
  desiredStatus,
  queuedCount = 0,
  nextPostLabel = "",
  lastFillAt = null,
}) => {
  if (
    effectiveStatus === AUTOMATION_EFFECTIVE_STATUS.PAUSED ||
    effectiveStatus === AUTOMATION_EFFECTIVE_STATUS.OFF ||
    effectiveStatus === AUTOMATION_EFFECTIVE_STATUS.ENDED ||
    desiredStatus === AUTOMATION_EFFECTIVE_STATUS.PAUSED ||
    desiredStatus === AUTOMATION_EFFECTIVE_STATUS.OFF
  ) {
    return false;
  }

  return !lastFillAt && queuedCount === 0 && !nextPostLabel;
};
